import React from 'react';
import { FieldArray } from 'redux-form';
import InsurerCommissionTable from '../../../broker/components/BrokerForm/components/tabsContent/components/InsurerCommissionTable/InsurerCommissionTable';
import { Box } from '../../../../common/components';

const BrokerApplicationCommissions = ({ availableProducts, commissions }) => {
  return (
    <Box>
      {commissions?.map((comm, index) => {
        const product = availableProducts.find((product) => comm.product === product.id);
        if (product) {
          return (
            <>
              <FieldArray
                productName={product.name}
                name={`data.attributes.broker_commission.${index}.rates`}
                component={InsurerCommissionTable}
                availableProducts={availableProducts}
              />
            </>
          );
        }
      })}
    </Box>
  );
};

export default BrokerApplicationCommissions;
